import angular from 'angular';

import core from './busqueda/core';
import config from './busqueda/config';
import filtros from './busqueda/filtros';
import interceptores from './busqueda/interceptores';
import directivas from './busqueda/directivas';
import servicios from './busqueda/servicios';
import componentes from './busqueda/componentes';
const MODULE_NAME = 'buscador.app';

const ngModule=angular.module(MODULE_NAME, [
  core,
  config,
  filtros,
  interceptores,
  directivas,
  servicios,
  componentes
]);

ngModule.config(['$httpProvider',($httpProvider)=>{
   //$httpProvider.interceptors.push('requestFactory');
}]);

export default MODULE_NAME;


// WEBPACK FOOTER //
// ./src/app.module.js